import { EDeviceConfigActions } from '@/store/deviceConfigStore/DeviceConfigStoreTypes'

export const deviceConfigFr = {
    api: {
        error: {
            [EDeviceConfigActions.CREATE_DEVICE_CONFIG]:
                'Erreur lors de la création de la configuration des appareils {name} ',
            [EDeviceConfigActions.DELETE_DEVICE_CONFIG]:
                'Erreur lors de la suppression de la configuration des appareils {name} ',
            [EDeviceConfigActions.FETCH_DEVICE_CONFIG]:
                'Erreur lors de la récupération de la configuration des appareils',
            [EDeviceConfigActions.FETCH_DEVICE_CONFIGS]:
                'Erreur lors de la récupération des configurations des appareils',
            [EDeviceConfigActions.UPDATE_DEVICE_CONFIG]:
                'Erreur lors de la modification de la configuration des appareils {name}',

            createDeviceTemplateKey:
                'Erreur lors de la création de la clé de configuration {name} ',
            deleteDeviceTemplateKey:
                'Erreur lors de la suppression de la clé de configuration {name} ',
            fetchDeviceTemplateKey: 'Erreur lors de la récupération de la clé de configuration',
            fetchDeviceTemplateKeys: 'Erreur lors de la récupération des clés de configuration',
            updateDeviceTemplateKey:
                'Erreur lors de la modification de la clé de configuration {name}',

            fetchDeviceFirmware: 'Erreur lors de la récupération du firmware {name} ',
            fetchDeviceFirmwares: 'Erreur lors de la récupération des firmwares ',
            createDeviceFirmware: 'Erreur lors de la création du firmware {name} ',
            updateDeviceFirmware: 'Erreur lors de la mise à jour du firmware {name} ',
            deleteDeviceFirmware: 'Erreur lors de la suppression du firmware {name} ',
            exportDeviceFirmwares: "Erreur lors d'export du firmware {name}",

            [EDeviceConfigActions.CREATE_DEVICE_TYPE]:
                "Erreur lors de la création de la configuration du type d'appareil {name} ",
            [EDeviceConfigActions.DELETE_DEVICE_TYPE]:
                "Erreur lors de la suppression du type d'appareil {name}",
            [EDeviceConfigActions.FETCH_DEVICE_TYPE]:
                "Erreur lors de la récupération du type d'appareil",
            [EDeviceConfigActions.FETCH_DEVICE_TYPES]:
                "Erreur lors de la récupération des types d'appareil",
            [EDeviceConfigActions.UPDATE_DEVICE_TYPE]:
                "Erreur lors de la modification des types d'appareil {name}"
        },
        success: {
            createDeviceConfig:
                'Création de la configuration des appareils {name} effectuée avec succès !',
            deleteDeviceConfig:
                'Suppression de la configuration des appareils {name} effectuée avec succès !',
            fetchDeviceConfig:
                'Récupération de la configuration des appareils effectuée avec succès !',
            fetchDeviceConfigs:
                'Récupération des configurations des appareils effectuée avec succès !',
            updateDeviceConfig:
                'Modification(s) de la configuration des appareils {name} effectuée(s) avec succès !',

            createDeviceTemplateKey:
                'Création de la clé de configuration {name} effectué avec succès',
            deleteDeviceTemplateKey:
                'Suppression de la clé de configuration {name} effectué avec succès',
            fetchDeviceTemplateKey: 'Récupération de la clé de configuration effectué avec succès',
            fetchDeviceTemplateKeys: 'Récupération des clés de configuration effectué avec succès',
            updateDeviceTemplateKey:
                'Modification de la clé de configuration {name} effectué avec succès',

            fetchDeviceFirmware: 'Récupération du firmware {name} effectuée avec succès !',
            fetchDeviceFirmwares: 'Récupération des firmwares effectuée avec succès !',
            createDeviceFirmware: 'Création du firmware {name} effectuée avec succès !',
            updateDeviceFirmware: 'Mise à jour du firmware {name} effectuée avec succès !',
            deleteDeviceFirmware: 'Suppression du firmware {name} effectuée avec succès !',
            exportDeviceFirmwares: 'Export du firmware effectuée avec succès !',

            [EDeviceConfigActions.CREATE_DEVICE_TYPE]:
                "Création du type d'appareil effectuée avec succès !",
            [EDeviceConfigActions.DELETE_DEVICE_TYPE]:
                "Suppression du type d'appareil {name} effectuée avec succès !",
            [EDeviceConfigActions.FETCH_DEVICE_TYPE]:
                "Récupération du type d'appareil {name} effectuée avec succès !",
            [EDeviceConfigActions.FETCH_DEVICE_TYPES]:
                "Récupération des types d'appareil effectuée avec succès !",
            [EDeviceConfigActions.UPDATE_DEVICE_TYPE]:
                "Mise à jour du type d'appareil {name} effectuée avec succès !"
        }
    },
    tabs: {
        configurations: 'Configurations',
        templateKeys: 'Clés de configuration',
        types: "Types d'appareils",
        firmwares: 'Firmwares'
    },
    firmware: {
        buttons: {
            createFirmware: 'Créer un firmware',
            uploadFile: 'Uploader un fichier',
            replaceFile: 'Remplacer le fichier'
        },
        model: {
            now: 'Maintenant',
            later: 'Plus tard',
            undefined: 'Non défini',
            name: 'Nom',
            description: 'Description',
            channel: 'Canal',
            canDowngrade: 'Peut être downgradée',
            releaseAt: 'Date de publication'
        },
        title: {
            informations: 'Informations'
        },
        table: {
            channel: 'Canal',
            deviceTypeName: "Type d'appareil",
            download: 'Téléchargement',
            name: 'Nom',
            releaseAt: 'Date de publication'
        }
    },
    types: {
        buttons: {
            createType: "Créer un type d'appareil",
            createNewType: "Créer ce type d'appareil",
            updateType: 'Enregistrer les modifications'
        },
        model: {
            name: 'Nom'
        },
        table: {
            name: 'Nom'
        },
        title: {
            informations: 'Informations'
        }
    },
    template: {
        buttons: {
            createTemplate: 'Créer un template',
            updateTemplate: 'Enregistrer les modifications'
        },
        model: {
            deviceType: "Type d'appareil",
            version: 'N° de version'
        },
        table: {
            deviceTypeName: "Type d'appareil",
            propertyType: 'Type de la propriété',
            version: 'Version'
        },
        title: {
            informations: 'Informations',
            newKey: 'Nouvelle clé',
            templateKeys: 'Clés et configuration'
        }
    },
    templateKeys: {
        buttons: {
            addNewExcluded: 'Ajouter une valeur',
            addNewValue: 'Ajouter une valeur',
            addNewPair: 'Ajouter une paire',
            createKey: 'Créer une clé',
            createNewKey: 'Créer et ajouter cette nouvelle clé',
            updateKey: 'Mettre à jour la clé'
        },
        detail: {
            addKey: 'Ajouter une clé existante'
        },
        model: {
            category: 'Catégorie',
            default: 'Valeur par défaut',
            description: 'Description',
            excluded: 'Valeurs exclues',
            isAdmin: 'Uniquement pour les administrateurs',
            isAdvanced: 'Configuration avancée',
            key: 'Clé',
            masked: 'Champ afficher/cacher',
            range: 'Plage de valeurs',
            readOnly: 'Lecture seule',
            translation: "Nom d'affichage",
            propertyType: 'Type de propriété',
            type: 'Type',
            unit: 'Unité',
            values: 'Valeurs',
            enumValues: "Valeurs de l'enum",
            enumLabels: 'Labels associés'
        },
        table: {
            key: 'Nom de la clé',
            description: 'Description',
            propertyType: 'Type de la propriété',
            isAdmin: 'Uniquement pour les admins'
        },
        title: {
            newKey: 'Nouvelle clé',
            editKey: 'Editer la clé'
        }
    }
}
